import React from "react";
import { useNavigate, useLocation } from "react-router-dom";

// Ako imaš slike, uvezi ih ovako:
import socerPlayerIcon from "../../Assets/Icons/soccer-player.png";
import championshipIcon from "../../Assets/Icons/championship.png";
import homeIcon from "../../Assets/Icons/home.png";

const BottomNavigation = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  // Helper funkcija za navigaciju
  const handleNavigate = (path) => {
    navigate(path);
    scrollToTop();
  };

  return (
    <nav className="bottom-nav">
      {/* Naslovna - putanja "/" */}
      <div
        className={`nav-item ${location.pathname === "/" ? "active" : ""}`}
        onClick={() => handleNavigate("/")}
      >
        <img src={homeIcon} alt="Naslovna" />
        <span>Naslovna</span>
      </div>

      {/* Završnica - putanja "/zavrsnica" */}
      <div
        className={`nav-item ${location.pathname === "/zavrsnica" ? "active" : ""}`}
        onClick={() => handleNavigate("/zavrsnica")}
      >
        <img src={championshipIcon} alt="Završnica" />
        <span>Završnica</span>
      </div>

      {/* Strijelci - putanja "/strijelci" */}
      <div
        className={`nav-item ${location.pathname === "/strijelci" ? "active" : ""}`}
        onClick={() => handleNavigate("/strijelci")}
      >
        <img src={socerPlayerIcon} alt="Strijelci" />
        <span>Strijelci</span>
      </div>
    </nav>
  );
};

export default BottomNavigation;
